import { classNames } from 'shared/lib/classNames/classNames';
import { useEffect, useState } from 'react';
import cls from './PreloadImg.module.scss';

interface PreloadImgProps {
    className?: string
    images: string[]
}

export const PreloadImg = (props: PreloadImgProps) => {
    const {
        className,
        images,
    } = props;
    const [isLoading, setIsLoading] = useState<boolean>(false);
    useEffect(() => {
        setTimeout(() => {
            setIsLoading(true);
        }, 100);
    }, []);

    return (
        <div className={classNames(cls.PreloadImg, {}, [className])}>
            {isLoading
                && (
                    <div>
                        {images.map((img) => (
                            <img key={img} src={img} alt="Фоновое изображение" />
                        ))}
                    </div>
                )}
        </div>
    );
};
